import { createI18n } from "vue-i18n";
import store from "../store";

async function loadLocaleMessages() {
  const modules = import.meta.glob("../assets/locales/*.json");
  const messages: Record<string, any> = {};
  
  for (const path in modules) {
    const module = await modules[path]() as { default: any }; // JSON 파일 로드
    const locale = path.match(/([A-Za-z0-9-_]+)\.json$/i)?.[1];
    if (locale) messages[locale] = module.default;
  }

  return messages;
}

export async function setupI18n() {
  const messages = await loadLocaleMessages();

  return createI18n({
    legacy: false,
    locale: store.getters["i18n/getLocale"](),
    fallbackLocale: store.getters["i18n/getFallbackLocale"](),
    globalInjection: true,
    messages,
  });
}
